export default {"src":"/_next/static/media/money-bag-outline.c9e33301.svg","height":24,"width":18,"blurWidth":0,"blurHeight":0};